@if(!!model){
<div class="flex flex-justify-center p-b-5">
    <ng-form name="giftcardForm"
             #form="ngForm"
             novalidate
             class="flex flex-column-s w-12 wrap-without-padding">
        <div class="w-8 w-6-m w-12-s p-r-1 p-r-0-s">
            <div class="_galleryContainer bg-col-41">
                <!-- gitf card main image XLM -->
                <!-- <div stickyNative
                     [stickyNativeOff]="stickyOff"> -->
                <div class="ratio-4-3">
                    <div class="fill flex flex-middle flex-justify-center">
                        <div class="ratio-3-2 _giftcardImage"
                             [class.cursor-pointer]="isPersonalisePlaceholder"
                             (click)="clickOnGallery()">
                            @if(canDisplayCustomImage) {
                            <div class="fill"
                                 [style]="'width: 100%; height: 100%; background-image: url(' + customImageSrc + '); background-size: cover; background-position: center;'">
                            </div>
                            } @else {
                            <img class="rf"
                                 [image]="model.data.image" />
                            }
                        </div>
                    </div>
                </div>
            </div>
            @if(model.data.description || model.parent?.data.description) {
            <div *ifSize="'!S'"
                 class="wrap">
                <p class="h3 m-t-9">{{'Product details' | translate}}</p>
                <div class="m-t-9 m-b-9 w-12 bg-col-42"
                     style="height: 1px"></div>
                <p class="p1 w-10"
                   [innerHTML]="model.data.description || model.parent?.data.description"></p>
            </div>
            }
        </div>

        <div class="w-4 w-6-m w-12-s p-t-9 p-t-3-s _rightColumn">

            <h2 class="h2 wrap-s">{{model.data?.name}}</h2>

            <giftcards-product-configurable-options class="block m-t-9"
                                                    [product]="model"
                                                    [request]="request"
                                                    [form]="form"
                                                    [wrapElements]="client.isS"
                                                    (init)="matchBest($event.data)"
                                                    (selectionChange)="matchBest($event.data)">
            </giftcards-product-configurable-options>

            <div class="m-t-9 wrap-s">
                <giftcards-amount-selector class="block"
                                           [product]="model"
                                           [form]="form"
                                           [request]="request"
                                           (update)="onRequestChange()"></giftcards-amount-selector>

                <div class="w-12 m-t-9">
                    <p class="p1">{{'3. Send by email to' | translate}}</p>

                    <div class="flex m-t-2">
                        <button type="button"
                                (click)="setRecipientType(ERecipientType.recipient)"
                                [ngClass]="{'_active': showEmailForm}"
                                class="c-6-set m-b-0 _optionButton">
                            {{'The recipient' | translate}}
                        </button>

                        <button type="button"
                                (click)="setRecipientType(ERecipientType.myself)"
                                [ngClass]="{'_active': !showEmailForm}"
                                class="c-6-set m-b-0 _optionButton">{{'Myself'
                            | translate}}

                        </button>
                    </div>

                    @switch (request.recipientType) {
                    @case (ERecipientType.recipient) {
                    <div>
                        <input-wrap class="block m-t-5"
                                    [canShowValidate]="!!request.am_giftcard_recipient_email?.length || undefined">
                            <input class="input"
                                   [muiInput]="'Recipient\'s email address' | translate"
                                   type="email"
                                   email
                                   loqateEmail
                                   [name]="'recipient_email'"
                                   [reverse]="true"
                                   [(ngModel)]="request.am_giftcard_recipient_email"
                                   autocomplete="none"
                                   [required]="request.recipientType === ERecipientType.recipient" />
                        </input-wrap>
                        <input-wrap class="block m-t-5"
                                    [messages]="{validateEqual : 'Emails are not the same.'}"
                                    [canShowValidate]="!!recipient_email_confirmation?.length || undefined">
                            <input class="input"
                                   [muiInput]="'Confirm recipient\'s email address' | translate"
                                   type="email"
                                   email
                                   name="recipient_email_confirmation"
                                   [matchCheck]="'recipient_email'"
                                   [(ngModel)]="recipient_email_confirmation"
                                   autocomplete="none"
                                   [required]="request.recipientType === ERecipientType.recipient" />
                        </input-wrap>
                        <input-wrap class="block m-t-5"
                                    name="recipient_name">
                            <input class="input"
                                   [muiInput]="'To (recipient\'s name)' | translate"
                                   type="text"
                                   name="recipient_name"
                                   [(ngModel)]="request.am_giftcard_recipient_name"
                                   autocomplete="none"
                                   [required]="request.recipientType === ERecipientType.recipient" />
                        </input-wrap>
                        <input-wrap class="block m-t-5"
                                    name="sender_name">
                            <input class="input"
                                   [muiInput]="'From (your name)' | translate"
                                   type="text"
                                   name="sender_name"
                                   [(ngModel)]="request.am_giftcard_sender_name"
                                   autocomplete="none"
                                   [required]="request.recipientType === ERecipientType.recipient" />
                        </input-wrap>
                        <input-wrap class="block m-t-5 pos-relative w-12">
                            <textarea class="textarea b-a b-col-4"
                                      [muiInput]="'Personalised gift message (optional)' | translate"
                                      name="recipient_message"
                                      [(ngModel)]="request.am_giftcard_message"
                                      autocomplete="none"
                                      maxlength="400"></textarea>
                            <p class="c1 col-12 m-t-2 flex flex-justify-between italic"><span>
                                    {{'% characters remaining' | translate : 400 -
                                    (request.am_giftcard_message?.length || 0)}}
                                </span><span>{{request.am_giftcard_message?.length || 0}}/400</span>
                            </p>
                        </input-wrap>
                    </div>
                    }
                    @case (ERecipientType.myself) {
                    <p class="m-t-6 p1">
                        {{'We’ll email your e-gift card to the email address you use to place your order.' |
                        translate}}
                    </p>
                    }
                    }
                </div>

                <div class="w-12 m-t-8">
                    <p class="p1 m-b-2">{{'4. Send E-Gift Voucher' | translate}}</p>

                    <div class="flex">
                        <button type="button"
                                (click)="toggleDeliveryDateType(true)"
                                [ngClass]="{'_active': sendGiftCardImmediately}"
                                class="c-6-set m-b-0 _optionButton">{{'Immediately'
                            | translate}}

                        </button>

                        <button type="button"
                                (click)="toggleDeliveryDateType(false)"
                                [ngClass]="{'_active': !sendGiftCardImmediately}"
                                class="c-6-set m-b-0 _optionButton">
                            {{'Choose a date' | translate}}
                        </button>
                    </div>

                    @if (sendGiftCardImmediately) {
                    <p class="p1 m-t-5">
                        {{
                        'Your e-gift voucher email will be sent to the recipient within 15 minutes of the order being
                        confirmed in checkout.' | translate
                        }}
                    </p>
                    }

                    @if (!sendGiftCardImmediately) {
                    <calendar class="w-12 m-t-5 pos-relative"
                              [options]="calendarOptions"
                              name="delivery_date"
                              [(ngModel)]="request.am_giftcard_date_delivery">
                    </calendar>
                    @if (request.am_giftcard_date_delivery) {
                    <p class="m-t-5"><span class="p1">
                            {{'Your e-gift voucher email will be sent to the recipient at 8am on' |
                            translate}}</span>&nbsp;<span class="p1"
                              style="font-weight: 700;">{{request.am_giftcard_date_delivery | date: 'EEEE d
                            MMMM'}}.</span>
                    </p>
                    }
                    }
                </div>

                <giftcards-add-to-basket class="w-12 m-t-9"
                                         (success)="onSuccess()"
                                         [product]="model"
                                         [form]="form"
                                         [model]="model"
                                         [basketRequest]="request"
                                         [request]="request"></giftcards-add-to-basket>

                <!-- Accordion item / delivery and returns -->
                <expandable class="b-t b-col-4 m-t-9 m-t-7-s block p-t p-b"
                            [addBorder]="false"
                            [expandableId]="['filter', 'sort-options']"
                            expandableIcon="plus">
                    <div expandableTitle
                         class="p1">
                        {{'FAQs' | translate}}
                    </div>

                    <div class="p-t-5 p2"
                         expandableBody
                         [innerHtml]="model.data.faq || model.parent?.data.faq"></div>

                </expandable>
            </div>
        </div>
    </ng-form>
</div>
}
<!--  <div id="giftcard-main-img"></div> -->
<icms-outlet-block [name]="'Giftcard page'"
                   [variant]="'giftcard-page'"></icms-outlet-block>